function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { DEBUG } from '@glimmer/env';
import Modifier from 'ember-modifier';
import deepEqual from 'fast-deep-equal';
import { registerDestructor } from '@ember/destroyable';
import { macroCondition, dependencySatisfies } from '@embroider/macros';
const WATCHED_ELEMENTS = DEBUG ? new WeakSet() : undefined;
let modifier;
if (macroCondition(dependencySatisfies('ember-modifier', '>=3.2.0 || 4.x'))) {
  var _class, _descriptor;
  modifier = (_class = class InViewportModifier extends Modifier {
    constructor(...args) {
      super(...args);
      _initializerDefineProperty(this, "inViewport", _descriptor, this);
      _defineProperty(this, "name", 'in-viewport');
      _defineProperty(this, "lastOptions", void 0);
      _defineProperty(this, "element", null);
    }
    modify(element, positional, named) {
      this.element = element;
      this.positional = positional;
      this.named = named;
      this.validateArguments();
      if (!this.didSetup) {
        this.setupWatcher(element);
        registerDestructor(() => this.destroyWatcher(element));
      } else if (this.hasStaleOptions) {
        this.destroyWatcher(element);
        this.setupWatcher(element);
      }
    }
    get options() {
      // eslint-disable-next-line no-unused-vars
      const {
        onEnter,
        onExit,
        ...options
      } = this.named;
      return options;
    }
    get hasStaleOptions() {
      return !deepEqual(this.options, this.lastOptions);
    }
    validateArguments() {
      assert(`'{{in-viewport}}' does not accept positional parameters. Specify listeners via 'onEnter' / 'onExit'.`, this.positional.length === 0);
      assert(`'{{in-viewport}}' either expects 'onEnter', 'onExit' or both to be present.`, typeof this.named.onEnter === 'function' || typeof this.named.onExit === 'function');
    }
    onEnter(...args) {
      if (this.named.onEnter) {
        this.named.onEnter.call(null, this.element, ...args);
      }
      if (!this.options.viewportSpy) {
        this.inViewport.stopWatching(this.element);
      }
    }
    onExit(...args) {
      if (this.named.onExit) {
        this.named.onExit.call(null, this.element, ...args);
      }
    }
    setupWatcher(element) {
      assert(`'${element}' is already being watched. Make sure that '{{in-viewport}}' is only used once on this element and that you are not calling 'inViewport.watchElement(element)' in other places.`, !WATCHED_ELEMENTS.has(element));
      if (DEBUG) WATCHED_ELEMENTS.add(element);
      this.inViewport.watchElement(element, this.options, this.onEnter, this.onExit);
      this.lastOptions = this.options;
    }
    destroyWatcher(element) {
      if (DEBUG) WATCHED_ELEMENTS.delete(element);
      this.inViewport.stopWatching(element);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "inViewport", [service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "onEnter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onExit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onExit"), _class.prototype)), _class);
} else {
  var _class2, _descriptor2;
  modifier = (_class2 = class InViewportModifier extends Modifier {
    constructor(...args) {
      super(...args);
      _initializerDefineProperty(this, "inViewport", _descriptor2, this);
      _defineProperty(this, "name", 'in-viewport');
      _defineProperty(this, "lastOptions", void 0);
    }
    get options() {
      // eslint-disable-next-line no-unused-vars
      const {
        onEnter,
        onExit,
        ...options
      } = this.args.named;
      return options;
    }
    get hasStaleOptions() {
      return !deepEqual(this.options, this.lastOptions);
    }
    validateArguments() {
      assert(`'{{in-viewport}}' does not accept positional parameters. Specify listeners via 'onEnter' / 'onExit'.`, this.args.positional.length === 0);
      assert(`'{{in-viewport}}' either expects 'onEnter', 'onExit' or both to be present.`, typeof this.args.named.onEnter === 'function' || typeof this.args.named.onExit === 'function');
    }
    onEnter(...args) {
      if (this.args.named.onEnter) {
        this.args.named.onEnter.call(null, this.element, ...args);
      }
      if (!this.options.viewportSpy) {
        this.inViewport.stopWatching(this.element);
      }
    }
    onExit(...args) {
      if (this.args.named.onExit) {
        this.args.named.onExit.call(null, this.element, ...args);
      }
    }
    setupWatcher() {
      assert(`'${this.element}' is already being watched. Make sure that '{{in-viewport}}' is only used once on this element and that you are not calling 'inViewport.watchElement(element)' in other places.`, !WATCHED_ELEMENTS.has(this.element));
      if (DEBUG) WATCHED_ELEMENTS.add(this.element);
      this.inViewport.watchElement(this.element, this.options, this.onEnter, this.onExit);
      this.lastOptions = this.options;
    }
    destroyWatcher() {
      if (DEBUG) WATCHED_ELEMENTS.delete(this.element);
      this.inViewport.stopWatching(this.element);
    }
    didInstall() {
      this.setupWatcher();
    }
    didUpdateArguments() {
      if (this.hasStaleOptions) {
        this.destroyWatcher();
        this.setupWatcher();
      }
    }
    didReceiveArguments() {
      this.validateArguments();
    }
    willRemove() {
      this.destroyWatcher();
    }
  }, (_descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "inViewport", [service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "onEnter", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onEnter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onExit", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onExit"), _class2.prototype)), _class2);
}
export default modifier;